import { css, html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { Style } from "./Styles";
import { BaseElement } from "./BaseElement";
import { litIf } from "./LitUtils";
import { IPlace } from "../models/Models";
import { formatLocation, formatPlaceAddress } from "../Format";

import geomagnetism from "@cristianob/geomagnetism";

import "./Distance/Distance";
import "./CopyToClipboard";
import { watch } from "./internal/watch";

@customElement("ds-place-details")
export class PlaceDetails extends BaseElement {
    static override styles = [
        Style,
        css`
            :host {
                display: block;
            }

            .container {
                display: flex;
                flex-direction: column;
                width: 100%;
                gap: 0em;
            }

            .address {
                font-style: italic;
            }
        `,
    ];
    @property({ type: Object }) place?: IPlace;
    @property({ type: Number }) distFromWater?: number;
    @property({ type: Boolean }) showSimple = false;

    @state() protected _geoMagnetism?: string;

    @watch("place")
    onPlaceUpdate() {
        this._geoMagnetism = undefined;
        if (this.place) {
            try {
                this._geoMagnetism = geomagnetism
                    .model()
                    .point([this.place.data.location.lat, this.place.data.location.lon])
                    .decl.toFixed(0);
            } catch (error) {
                // model is out of date
            }
        }
    }

    override render() {
        if (this.place) {
            return html`<div class="container">
                ${litIf(
                    !!this.place.data.address,
                    () => html` <span class="address">${formatPlaceAddress(this.place)}</span> `
                )}
                <div class="flex-row">
                    <span>Feature type: ${this.place.data.spelioData.type}</span>
                    ${litIf(
                        !!this.place.data.spelioData.systemName,
                        () => html` <span>System: ${this.place?.data.spelioData.systemName}</span>`
                    )}
                </div>
                ${litIf(
                    !this.showSimple,
                    () =>
                        html` ${litIf(
                                !!this.place?.data.altitude,
                                () =>
                                    html` <span
                                        >Elevation:
                                        <ds-distance
                                            style="display:inline-block"
                                            .distance=${this.place?.data.altitude ?? undefined}
                                        ></ds-distance
                                    ></span>`
                            )}
                            ${litIf(
                                !!this.distFromWater,
                                () =>
                                    html` <span
                                        >Height above ground water: ${this.distFromWater}
                                        meters</span
                                    >`
                            )}
                            <span
                                >Location: ${formatLocation(this.place?.data.location)}
                                <ds-copy-to-clipboard
                                    .text=${formatLocation(this.place?.data.location)}
                                ></ds-copy-to-clipboard>
                                ${litIf(
                                    !this.place?.data.locationKnown,
                                    () =>
                                        html`><span style="font-style:italics">[Unconfirmed]</span>`
                                )}</span
                            >

                            ${litIf(
                                this._geoMagnetism,
                                () =>
                                    html`<span
                                        >Magnetic declination: ${`${this._geoMagnetism}°`}</span
                                    >`
                            )}`
                )}
            </div>`;
        }

        return html``;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-place-details": PlaceDetails;
    }
}
